import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { UAParser } from 'ua-parser-js';

import './Camera.css';

const getBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = (error) => reject(error);
});

class Camera extends React.Component {
  constructor(props) {
    super(props);

    this.initialiseMedia = this.initialiseMedia.bind(this);
    this.takePhoto = this.takePhoto.bind(this);
    this.selectPhoto = this.selectPhoto.bind(this);

    this.state = {
      container: this.props.container,
    };
  }

  componentDidMount() {
    this.initialiseMedia();
  }

  componentDidUpdate(prevProps) {
    // When the user clicks Retake, capturedImage goes from a value to null.
    // Re-initialise the camera stream at that point instead of using setTimeout.
    if (prevProps.capturedImage && !this.props.capturedImage) {
      this.initialiseMedia();
    }
  }

  initialiseMedia() {
    const parser = new UAParser();
    const results = parser.getResult();

    if (results.os.name === 'iOS') {
      $(`#${this.props.container} #pick-image`).css('display', 'block');
      $(`#${this.props.container} #overlay`).css('display', 'none');
      $(`#${this.props.container} #capture`).css('display', 'none');
    } else {
      if (!('mediaDevices' in navigator)) {
        navigator.mediaDevices = {};
      }

      if (!('getUserMedia' in navigator.mediaDevices)) {
        navigator.mediaDevices.getUserMedia = (constraints) => {
          const getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

          if (!getUserMedia) {
            return Promise.reject();
          }

          return new Promise((resolve, reject) => {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }

      // Request an HD feed to prevent blurry captures
      const constraints = {
        video: {
          facingMode: 'environment',
          width: { ideal: 1920 },
          height: { ideal: 1080 },
        },
      };

      navigator.mediaDevices.getUserMedia(constraints)
        .then((stream) => {
          const videoPlayer = document.querySelector(`#${this.state.container} #player`);
          if (videoPlayer) {
            videoPlayer.srcObject = stream;
            videoPlayer.style.display = 'block';
          }
        })
        .catch(() => {
          $(`#${this.props.container} #pick-image`).css('display', 'block');
          $(`#${this.props.container} #overlay`).css('display', 'none');
          $(`#${this.props.container} #capture`).css('display', 'none');
        });
    }
  }

  takePhoto() {
    const videoElement = document.querySelector(`#${this.state.container} #player`);

    // Off-screen canvas — does not touch the DOM
    const canvasElement = document.createElement('canvas');
    canvasElement.width = videoElement.videoWidth || 1920;
    canvasElement.height = videoElement.videoHeight || 1080;

    const context = canvasElement.getContext('2d');
    context.drawImage(videoElement, 0, 0, canvasElement.width, canvasElement.height);

    // Stop video tracks to release the camera while previewing the photo
    if (videoElement.srcObject) {
      videoElement.srcObject.getVideoTracks().forEach((track) => track.stop());
    }

    const rawBase64 = canvasElement.toDataURL('image/jpeg', 0.95);
    this.props.onPhotoCaptured(rawBase64);
  }

  async selectPhoto(event) {
    const file = event.target.files[0];
    if (!file) return;

    const fileBase64 = await getBase64(file);
    this.props.onPhotoCaptured(fileBase64);
  }

  render() {
    // Show the captured photo preview with a Retake option
    if (this.props.capturedImage) {
      return (
        <div id="camera-preview" style={{ textAlign: 'center' }}>
          <img
            src={this.props.capturedImage}
            alt="Preview"
            style={{
              maxWidth: '100%',
              maxHeight: '50vh',
              objectFit: 'contain',
              borderRadius: '4px',
            }}
          />
          <div style={{ marginTop: '15px' }}>
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => this.props.onClear()}
            >
              Retake Photo
            </button>
          </div>
        </div>
      );
    }

    // Show the live camera stream or file picker
    return (
      <div id="camera">
        {/* playsInline is required for iOS Safari — without it the camera won't work */}
        <video id="player" autoPlay playsInline width="100%" style={{ display: 'none' }} />
        <div id="overlay"><img src={this.props.overlay} alt="" /></div>
        <button type="button" className="btn camera-btn" id="capture" onClick={this.takePhoto}>
          Capture
        </button>
        <div id="pick-image" style={{ display: 'none' }}>
          <h6>Select an image to use:</h6>
          {/* capture="environment" forces the rear camera on mobile devices */}
          <input type="file" accept="image/*" capture="environment" id="image-picker" onChange={this.selectPhoto} />
        </div>
      </div>
    );
  }
}

Camera.propTypes = {
  onPhotoCaptured: PropTypes.func.isRequired,
  container: PropTypes.string.isRequired,
  overlay: PropTypes.string.isRequired,
  capturedImage: PropTypes.string,
  onClear: PropTypes.func.isRequired,
};

export default Camera;
